import { useEffect, useState, useRef, useContext } from "react";
import { Link } from "react-router-dom";

import { LayoutContext } from "../layout/";

import { getAllProducts, updateProduct, removeProduct } from '../preinvoice/storage';

import Loader from "../loader";
import { getEndpoint } from "../helper";

function useAutoHide(delay = 1000) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!visible) return;

        const timer = setTimeout(() => setVisible(false), delay);
        return () => clearTimeout(timer);
    }, [visible, delay]);

    return [visible, () => setVisible(true)];
}

export default function SelectedProducts(props) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [focusedId, setFocusedId] = useState(null);

    const [showToast, triggerToast] = useAutoHide(1500);

    const handleDelete = id => {
        removeProduct(id);
        setData(getAllProducts());
        //triggerToast();
    }

    const handleUpdate = (id, prevQuantity, mode) => {
        updateProduct(id, mode === '+' ? prevQuantity + 1 : prevQuantity - 1);
        setData(getAllProducts());
        //triggerToast();
    }

    const handleUpdate2 = (id, q) => {
        updateProduct(id, q);
        setData(getAllProducts());
        //triggerToast();
    }

    const ProductBox = ({ id, title, quantity, picture, focused, setFocusedId }) => {
        const [localQty, setLocalQty] = useState(quantity);
        const timeoutRef = useRef(null);
        const inputRef = useRef(null);

        useEffect(() => {
            setLocalQty(quantity);
        }, [quantity]);

        // مدیریت فوکوس
        useEffect(() => {
            if (focused && inputRef.current) {
                inputRef.current.focus();
            }
        }, [focused]);

        const handleFocus = () => setFocusedId(id);

        const handleChange = (e) => {
            let value = e.target.value;
            setLocalQty(value);

            if (timeoutRef.current) clearTimeout(timeoutRef.current);

            if (value === '') return;
            if (+value < 1) value = 1;

            timeoutRef.current = setTimeout(() => {
                setLocalQty(value);

                handleUpdate2(id, +value);

                // به جای setData(getAllProducts()) مقدار محلی را هم آپدیت می‌کنیم
                setData(prev => prev.map(item => item.id === id ? { ...item, quantity: +value } : item));
            }, 500);
        };

        const handleBlur = () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }

            if (localQty === '' || +localQty < 1) {
                const corrected = 1;
                setLocalQty(corrected);
                handleUpdate2(id, corrected);
                setData(prev => prev.map(item => item.id === id ? { ...item, quantity: corrected } : item));
            }
        };

        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/product-file/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }

        return (
            <div className='box p-r d-f ai-fe bc-w bw-1 bc--n3 br-3 mb-4'>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <Img />
                </div>
                <div className='px-2'>
                    <div className='p-a t-2'>{title}</div>
                    <div className='d-f ai-c mb-2'>
                        <div style={{ borderColor: '#acacac', width: '40%' }} className='mr-a fs-3 bw-1 br-3 d-f ai-c'>
                            <svg className='d-b fsh-0 fg-0' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={e => handleUpdate(id, quantity, '+')}>
                                <path fill='#075e54' d="M25.313 15.781h-8v8h-2.625v-8h-8v-2.625h8v-8h2.625v8h8v2.625z"></path>
                            </svg>
                            <input
                                ref={inputRef}
                                className='ta-c bc-t w-100'
                                type="number"
                                value={localQty}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onFocus={handleFocus}
                            />
                            <svg className='d-b fsh-0 fg-0 mr-a' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={e => handleUpdate(id, quantity, '-')}>
                                <path fill='#075e54' d="M25.313 15.781h-18.625v-2.625h18.625v2.625z"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" className='p-a l-1 t-1' onClick={e => handleDelete(id)}>
                    <path fill='#ff0000' d="M25.313 7.031l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
                </svg>
            </div>
        );
    }

    useEffect(() => {
        setPageTitle('لیست کالاهای انتخابی');

        setData(getAllProducts());
    }, []);

    if (data.length === 0) {
        return (
            <div className='d-f ai-c jc-c h-100' style={{ backgroundColor: '#f5f5f5' }}>
                <div>
                    <img className='w-9 mx-a mb-4' src={getEndpoint("/pwa/img/empty_cart.png")} />
                    <div>لیست خرید شما خالی است!</div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '9rem' }}>
                {data.map(x => {
                    return (
                        <ProductBox
                            key={x.id}
                            id={x.id}
                            title={x.title}
                            quantity={x.quantity}
                            picture={x.picture}
                            focused={focusedId === x.id}
                            setFocusedId={setFocusedId}
                        />
                    )
                })}
            </div>
            <Link to='/invoices' className='d-f ai-c jc-c c-w fs-3 _bc-b p-f b-0 l-0 w-100' style={{ height: '5rem' }}>پیش فاکتور</Link>

            {showToast && (
                <div className='toast p-f b-4 l-0 r-0 d-f jc-c'>
                    <div className='d-if px-5 py-3 br-999' style={{ backgroundColor: '#f0f0f0' }}>
                        لیست محصولات انتخابی بروزرسانی شد!
                    </div>
                </div>
            )}
        </>
    );
}